var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"MobileSliderWrapper",class:{ ruLocale: _vm.$i18n.locale==='ru-RU' }},[_c('Hooper',{class:{ ruLocale: _vm.$i18n.locale==='ru-RU' },attrs:{"settings":_vm.settings}},_vm._l((_vm.slides),function(slide){return _c('Slide',{key:slide.id},[_c('MobileSliderItem',{key:slide.id,attrs:{"slide":slide}})],1)}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }